import https from "@/lib/https";
import type {
  ExperienceDetail,
  ExperiencePayload,
  GetExperienceListParams,
} from "@/interface/profile";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/experiences/";

export const getExperienceList = async (
  params?: GetExperienceListParams,
): Promise<ApiResponse<ExperienceDetail[]>> => {
  return await https.get<ApiResponse<ExperienceDetail[]>>(BASE_URL, params);
};

export const getExperienceById = async (
  id: string,
): Promise<ApiResponse<ExperienceDetail>> => {
  return await https.get<ApiResponse<ExperienceDetail>>(`${BASE_URL}/${id}`);
};

export const createExperience = async (
  payload: ExperiencePayload,
): Promise<ApiResponse<ExperienceDetail>> => {
  return await https.post<ApiResponse<ExperienceDetail>>(BASE_URL, payload);
};

export const updateExperience = async (
  id: string,
  payload: ExperiencePayload,
): Promise<ApiResponse<ExperienceDetail>> => {
  return await https.put<ApiResponse<ExperienceDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchExperience = async (
  id: string,
  payload: Partial<ExperiencePayload>,
): Promise<ApiResponse<ExperienceDetail>> => {
  return await https.patch<ApiResponse<ExperienceDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteExperience = async (
  id: string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}`);
};
